import { Injectable } from '@angular/core';
import { CookieService } from '../../../shared/cookie.service';

@Injectable()
export class FeedRssCookieService {
    stopShowingCookie = 'pjm_hide_rss_popup';
    expireDays = 365;

    constructor(private cookieService: CookieService) { }

    addCookie(): void {
        this.cookieService.setCookie(this.stopShowingCookie, 'true', this.expireDays);
    }

    removeCookie(): void {
        this.cookieService.setCookie(this.stopShowingCookie, '', -1);
    }

    cookieExists(): boolean {
        return this.cookieService.getCookie(this.stopShowingCookie) !== '';
    }



}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/feed-rss-cookie.service.ts